import { render } from "./PageNotFoundView.vue?vue&type=template&id=693ba25f&ts=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__